import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetCetnerListResponse, GetListRequest } from '../../type/types';

// 센터 목록 조회
export const getCenterList = async (params: GetListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetCetnerListResponse>>(
    `/api/web/admins/partners/centers`,
    { params: query }
  );
  return res.data;
};
